{
  "home": "Басты бет",
  "games": "Ойындар",
  "casino": "Казино",
  "sports": "Спорт",
  "bonuses": "Бонустар",
  "wallet": "Касса",
  "menu": "Мәзір",
  "profile": "Кабинет",
  "login": "Кіру",
  "loginSoon": "Кіру — жақында"
}
